"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ palette, _components }) => ({
    dialogRoot: {
        padding: 30,
        paddingTop: 10,
        minHeight: 500,
        maxWidth: 555,
    },
    dividerRoot: {
        backgroundColor: palette.border.dark,
    },
    headerRow: {
        background: palette.status.overdueLight,
    },
    header: {
        padding: '15px 0px 15px 0px',
    },
    title: {
        marginBottom: 10,
    },
    sectionHeader: {
        marginTop: 15,
        borderBottom: 'solid',
        borderBottomColor: palette.border.dark,
        borderBottomWidth: 1,
    },
    dialogActions: {
        marginTop: 15,
    },
    qCard: {
        zIndex: 5000,
    },
});
exports.styles = styles;
